import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoginPage } from '../../../components/login.jsx';
import { buildLoginPath, sanitizeReturnTo } from '../return-to.js';

/**
 * Public login route. After success, navigates to sanitized returnTo.
 */
export function LoginRoute({ onLogin, authError, loggedIn }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const returnTo = sanitizeReturnTo(params.get('returnTo'));

  if (loggedIn) {
    return <Navigate to={returnTo} replace />;
  }

  return <LoginPage onLogin={onLogin} initialError={authError} />;
}

/**
 * Redirect unauthenticated users to /login?returnTo=...
 */
export function RequireAuth({ loggedIn, authChecking, children }) {
  const location = useLocation();

  if (authChecking) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-subtle)', color: 'var(--text-secondary)', fontSize: 14 }}>
        Validando sessão...
      </div>
    );
  }

  if (!loggedIn) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildLoginPath(returnTo)} replace />;
  }

  return children;
}
